import apiClient from './Api';
const PREFIX = '/annoucementsbanner';

const dismissAnnoucementsBar = (postData) => {
  return apiClient({
    url: `${PREFIX}/dismiss`,
    data: postData,
    method: 'POST'
  });
};

const getAllAnnoucementsBar = () => {
  return apiClient({
    url: `${PREFIX}/bar`,
    method: 'GET'
  });
};

const getAllAnnoucementsBanner = () => {
  return apiClient({
    url: `${PREFIX}`,
    method: 'GET'
  });
};

const deleteAnnoucementsBanner = postData => {
  return apiClient({
    url: `${PREFIX}`,
    data: postData,
    method: 'DELETE'
  });
};

const addEditAnnoucementsBanner = postData => {
  return apiClient({
    url: `${PREFIX}`,
    data: postData,
    method: 'POST'
  });
};

const announcementsBannerService = {
  dismissAnnoucementsBar,
  getAllAnnoucementsBar,
  getAllAnnoucementsBanner,
  deleteAnnoucementsBanner,
  addEditAnnoucementsBanner
};
export default announcementsBannerService;
